import { Observable } from 'rxjs/Observable'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import { empty } from 'rxjs/observable/empty'
import { of } from 'rxjs/observable/of'
import { concat, filter, map, take, tap, withLatestFrom } from 'rxjs/operators'
import { environment } from '../../../environments/environment'

import { ConversationStateConversationV1Enum } from '../../api/api/models/conversation-v1'
import { AppState } from '../../store'
import { ConversationType } from '../conversation'
import { LOAD_CONVERSATION_TEAMS } from '../team/store/actions'

export const getNumber = (val: string): number =>
  typeof val === 'number'
    ? val
    : Number.parseInt(val, 10)

export const getFromStoreOrAPI = ({store, action, selector}): Observable<any> => {
  return store
    .select(selector).pipe(
      tap((data: any) => {
        if (action.type === LOAD_CONVERSATION_TEAMS && !environment.production) {
          console.log(action.type, data)
        }
        if (!data.length) {
          store.dispatch(action)
        }
      }),
      take(1))
}

export interface CacheOptions {
  store: Store<any>
  actions$: Actions
  type: string
  selector: any
}

export const cacheFirst = ({store, actions$, type, selector}: CacheOptions) => {
  return actions$.pipe(
    ofType(type),
    withLatestFrom(store.select(selector)),
    filter(([action, arr]) => !arr.length),
    map(([a, b]) => a)
  )
}

/*
  Concatenates multiple actions.
 */
export const errorActions = (...actions) => actions.reduce((acc, cur) => acc.pipe(concat(of(cur))), empty())

export const getIdFromUrl = (url: string) => {
  const urlParts = url.split('/')
  return getNumber(urlParts[urlParts.length - 1])
}

export const getRandomPassword = () => {
  const passAt = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  const passArray = Array.from({length: 15})

  return passArray.map(function (_, index) {
    return index % 4 === 3 ? '-' : passAt.charAt(Math.random() * passAt.length)
  }).join('')
}

export const parseConversationType = (type: ConversationType): ConversationStateConversationV1Enum[] => {
  switch (type) {
    case ConversationType.Open:
      return [ConversationStateConversationV1Enum.Open, ConversationStateConversationV1Enum.Assigned]
    case ConversationType.Closed:
      return [ConversationStateConversationV1Enum.Closed]
    case ConversationType.Mine:
      return [ConversationStateConversationV1Enum.Assigned]
    case ConversationType.Unassigned:
      return [ConversationStateConversationV1Enum.Open]
    default:
      return [ConversationStateConversationV1Enum.Open, ConversationStateConversationV1Enum.Assigned]
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/utils/helpers.ts